import { useController } from "react-hook-form";
import { useBoolean } from "@miplatform/hooks";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

export const MiControlledTimerPicker = ({
  value,
  label,
  name,
  helperText = null,
  formControl: control = {},
  rules = {},
  valueModifier,
  disabled,
  sx = {},
  className,
  required,
  format = "HH:mm",
  ampm,
  strictInterval,
  minutesStep,
  ...props
}) => {
  const [open, handleOpen, handleClose] = useBoolean();
  const {
    field: { onChange, onBlur, value: defaultValue, ref },
    fieldState: { error },
  } = useController({ name, control, rules });

  const customOnChange = (event) => {
    const { value: inputValue } = event.target;
    onChange(valueModifier ? valueModifier(inputValue) : event);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <TimePicker
        inputRef={ref}
        label={label}
        value={value ?? defaultValue ?? ""}
        required={required}
        format={format}
        onChange={customOnChange}
        disabled={disabled}
        error={!!error}
        helperText={error ? error.message : helperText}
        ampm={ampm}
        minutesStep={minutesStep}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
            error: !!error,
            helperText: error ? error.message : helperText,
            required,
            onBlur,
            inputProps: {
              ref,
              "data-testid": `mi-time-picker-${name}`,
              readOnly: !!strictInterval,
              style: { cursor: "pointer" },
              onClick: () => {
                if (strictInterval) {
                  handleOpen();
                }
              },
            },
            sx: {
              ...sx,
            },
          },
        }}
        {...props}
      />
    </LocalizationProvider>
  );
};
